import React, {Component} from 'react';
import {CONFIG} from "../../common/config";

export default class FavouriteBadge extends Component {
    state = {
        liked: 0
    }

    componentDidMount() {
        this.getLiked()
        if (this.props.dynamic === "1") {
            setInterval(this.getLiked, 5000)
        }
    }

    getLiked = () => {
        try {
            fetch(CONFIG.GET_LIKED_COUNT, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                return response.json()
            }).then(body => {
                this.setState({
                    liked: body.liked
                })
            }).catch(error => {
            })
        } catch (error) {
        }
    }

    render() {
        return (
            <span>
                {this.state.liked > 0 ?
                    <span className="favourites-badge">{this.state.liked}</span> :
                    ''
                }
            </span>
        );
    }
}
